import { useState, useEffect } from 'react';
import Header from '../Section/Header';
export default function PageNotFound() {
  const [mounted, setMounted] = useState(false);
  const [glitchText, setGlitchText] = useState("404");

  useEffect(() => {
    setMounted(true);

    // Glitch effect for the 404 text
    const glitchInterval = setInterval(() => {
      const glitchChars = ["4", "0", "4", "█", "▓", "▒", "░"];
      const randomText = Array.from(
        { length: 3 },
        () => glitchChars[Math.floor(Math.random() * glitchChars.length)]
      ).join("");

      setGlitchText(randomText);

      setTimeout(() => setGlitchText("404"), 100);
    }, 2000);

    return () => clearInterval(glitchInterval);
  }, []);

  const floatingElements = Array.from({ length: 20 }, (_, i) => {
    const left = `${Math.random() * 100}%`;
    const top = `${Math.random() * 100}%`;
    const animationDelay = `${Math.random() * 2}s`;
    const animationDuration = `${2 + Math.random() * 2}s`;

    return (
      <div
        key={i}
        className="absolute animate-bounce opacity-20"
        style={{
          left,
          top,
          animationDelay,
          animationDuration,
        }}
      >
        {["⭐", "🌟", "✨", "💫", "🔮"][Math.floor(Math.random() * 5)]}
      </div>
    );
  });
  if (!mounted) return null;

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 flex items-center justify-center p-4 overflow-hidden relative">
        {/* Animated background elements */}
        {floatingElements}

        {/* Main content */}
        <div className="text-center relative z-10 max-w-2xl mx-auto">
          {/* Glitch 404 text */}
          <div className="relative mb-8">
            <h1 className="text-9xl md:text-[12rem] font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-purple-400 to-blue-400 select-none">
              {glitchText}
            </h1>
            <div className="absolute inset-0 text-9xl md:text-[12rem] font-bold text-red-500 opacity-30 animate-pulse">
              404
            </div>
          </div>

          {/* Content card */}
          <div className="backdrop-blur-xl bg-white/10 rounded-3xl p-8 md:p-12 shadow-2xl border border-white/20">
            <div className="mb-6">
              <div className="text-6xl mb-4 animate-bounce">🚀</div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
                Lost in Space
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                The page you're looking for has drifted into the digital void.
                But don't worry, we'll help you navigate back to safety!
              </p>
            </div>

            {/* Action buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={() => (window.location.href = "/")}
                className="group relative px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full text-white font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 hover:scale-105"
              >
                <span className="relative z-10">Take Me Home</span>
                <div className="absolute inset-0 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>

              <button
                onClick={() => window.history.back()}
                className="group px-8 py-4 border-2 border-white/30 rounded-full text-white font-semibold text-lg hover:bg-white/10 transform hover:-translate-y-1 transition-all duration-300 hover:scale-105"
              >
                Go Back
              </button>
            </div>

            {/* Search suggestion */}
            <div className="mt-8 p-4 bg-white/5 rounded-xl border border-white/10">
              <p className="text-gray-400 text-sm mb-3">
                Looking for something specific?
              </p>
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Search our site..."
                  className="flex-1 px-4 py-2 bg-white/10 border border-white/20 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                />
                <button className="px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg text-white font-medium hover:from-blue-600 hover:to-purple-600 transition-all duration-300">
                  Search
                </button>
              </div>
            </div>
          </div>

       
        </div>

        {/* Subtle animation overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 via-transparent to-blue-500/5 animate-pulse"></div>
      </div>
    </>
  );
}